export default {"src":"/komodo/_next/static/media/gleec-ios-qr.46ced5db.svg","height":164,"width":164,"blurWidth":0,"blurHeight":0};